import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SavedCreditCardsType } from '../../pages/PaymentPage/type';

export const savedCreditCardsSlice = createSlice({
  name: 'savedCreditCards',
  initialState: null as SavedCreditCardsType[] | null,
  reducers: {
    setSavedCreditCards: (state, action: PayloadAction<SavedCreditCardsType[] | null>) => action.payload,
  },
});

export const { setSavedCreditCards } = savedCreditCardsSlice.actions;
export default savedCreditCardsSlice.reducer;
